// src/styles/theme.js

const theme = {
  colors: {
    bgPrimary: "#0a0c10",
    bgSecondary: "#0d1017",
    bgCard: "#111620",
    bgCardHover: "#161d2a",
    bgNavbar: "rgba(10, 12, 16, 0.92)",
    gold: "#c9922a",
    goldLight: "#e0a83a",
    goldDark: "#a67520",
    goldMuted: "rgba(201, 146, 42, 0.15)",
    goldBorder: "rgba(201, 146, 42, 0.3)",
    white: "#ffffff",
    offWhite: "#f0ede8",
    textPrimary: "#ffffff",
    textSecondary: "#8a95a3",
    textMuted: "#5a6370",
    border: "rgba(255,255,255,0.07)",
    borderHover: "rgba(201, 146, 42, 0.4)",
    error: "#e05c5c",
    errorBg: "rgba(224, 92, 92, 0.1)",
    success: "#4caf80",
    successBg: "rgba(76, 175, 128, 0.1)",
    warning: "#e0a83a",
    warningBg: "rgba(224, 168, 58, 0.1)",
    overlay: "rgba(10, 12, 16, 0.85)",
  },
  fonts: {
    display: "'Playfair Display', Georgia, serif",
    body: "'DM Sans', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  lineHeights: {
    tight: 1.1,
    snug: 1.25,
    normal: 1.5,
    relaxed: 1.75,
  },
  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    "2xl": "3rem",
    "3xl": "4rem",
    "4xl": "6rem",
    "5xl": "8rem",
    section: "7rem",
  },
  borderRadius: {
    sm: "6px",
    md: "10px",
    lg: "16px",
    xl: "24px",
    "2xl": "32px",
    full: "9999px",
    card: "18px",
    button: "50px",
  },
  breakpoints: {
    xs: "375px",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
    "2xl": "1400px",
  },
  shadows: {
    sm: "0 2px 8px rgba(0,0,0,0.3)",
    md: "0 4px 20px rgba(0,0,0,0.4)",
    lg: "0 8px 40px rgba(0,0,0,0.5)",
    gold: "0 4px 24px rgba(201, 146, 42, 0.25)",
    goldLg: "0 8px 40px rgba(201, 146, 42, 0.35)",
    card: "0 2px 20px rgba(0,0,0,0.4)",
    cardHover: "0 8px 40px rgba(0,0,0,0.6)",
  },
  transitions: {
    fast: "0.15s ease",
    normal: "0.3s ease",
    slow: "0.5s ease",
    bounce: "0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
  },
  zIndex: {
    base: 1,
    dropdown: 100,
    sticky: 200,
    modal: 300,
    toast: 400,
    tooltip: 500,
  },
};

export default theme;
